import { Col, Row } from 'antd';
import MaterialRequestTable from '../../../components/MaterialRequestTable';

import Header from '../../../components/Header';
import { Link } from 'react-router-dom';
import { useState } from 'react';

function MaterialRequests() {
	const [isReady, setIsReady] = useState(false);

	return (
		<main
			data-testid="page-fastlane-material-requests"
			data-ready={isReady ? 'true' : 'false'}
		>
			<Header
			title="Material Requests"
			breadcrumbItems={[
				{
					title: <Link to="/">Home</Link>,
				},
				{
					title: 'Material Requests',
					},
				]}
			/>

			<Row>
				<Col span={24}>
					<MaterialRequestTable
						hiddenMaterialRequests={false}
						onReadyChange={(ready) => {
							if (ready) {
								setIsReady(true);
							}
						}}
					/>
				</Col>
			</Row>
		</main>
	);
}

export default MaterialRequests;
